import axios from 'axios';
import useAuthStore from '../utils/authStore';

// Create base axios instance
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for authentication
api.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for error handling
// api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     // Handle 401 Unauthorized errors
//     if (error.response?.status === 401) {
//       useAuthStore.getState().signOut();
//       window.location.href = '/login';
//     }
//     return Promise.reject(error);
//   }
// );

export default api;